import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Qs from 'qs'
// 載入 vue2-leaflet，依照自己需要載入組件
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from 'vue2-leaflet'
// 載入 css
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'
import UUID from 'vue-uuid'

Vue.use(UUID)
// 啟用載入的各組件
Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)
Vue.component('l-popup', LPopup)
Vue.component('l-icon', LIcon)

// 設定預設 icon

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.prototype.Qs = Qs
Vue.config.devtools = false
Vue.config.debug = false
Vue.config.silent = true
Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2)
const vue = new Vue({
  router,
  store,
  render: h => h(App)
})

vue.$mount('#app')
